import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';

const FilesPage = () => {
    const { t } = useTranslation();

    return (
        <Fragment>
            <Header hclass={'header--styleFour'} />
            <main className="main">
                <section className="filesPage sitePageSection">
                    <div className="container">
                        <div className="filesPage__heading">
                            <h1>{t('files.title')}</h1>
                        </div>

                        <div className="filesPage__empty" role="status">
                            <span className="filesPage__emptyIcon" aria-hidden="true">
                                <i className="fa-solid fa-folder-open"></i>
                            </span>
                            <div>
                                <h2>{t('files.empty_title')}</h2>
                                <p>{t('files.empty_text')}</p>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default FilesPage;
